import React from "react";
import "./Facility.css";

import businessIcon from "../Assets/Frontend_Assets/indepedent.webp";
import handmadeIcon from "../Assets/Frontend_Assets/handmade.webp";
import deliveryIcon from "../Assets/Frontend_Assets/fast.webp";
import fairIcon from "../Assets/Frontend_Assets/fair.webp";

const Facility = () => {
  const values = [
    {
      icon: businessIcon,
      title: "INDEPENDENT BUSINESS",
    },
    {
      icon: handmadeIcon,
      title: "HANDMADE WITH LOVE",
    },
    {
      icon: deliveryIcon,
      title: "FAST DELIVERY",
    },
    {
      icon: fairIcon,
      title: "FAIR WORKING CONDITIONS",
    },
  ];

  return (
    <div className="brand-values">
      {values.map((item, index) => (
        <div className="value-card" key={index}>
          <img src={item.icon} alt={item.title} />
          <p>{item.title}</p>
        </div>
      ))}
    </div>
  );
};

export default Facility;
